import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { NavLink, Link } from 'react-router-dom';
import $ from 'jquery';
import StartDatePicker from './StartDatePicker/StartDatePicker';
import EndDatePicker from './EndDatePicker/EndDatePicker';
import Checkbox from '@mui/material/Checkbox';
import lastOperationsIcon from './../img/last-operations-icon.png';
import { request } from '../../../config';
import YesNoModal from "../../../copms/Modal/YesNoModal"
import AsanVerification from '../../../copms/Modal/AsanVerification';
import { Autocomplete, Radio, TextField } from '@mui/material';
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';

function base64ToArrayBuffer(base64) {
    let binaryString = window.atob(base64);
    let binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
        let ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }
    return bytes;
}
function saveFile(name, type, data) {
    if (data !== null && navigator.msSaveBlob)
        return navigator.msSaveBlob(new Blob([data], { type: type }), name);
    var a = $("<a style='display: none;'/>");
    var url = window.URL.createObjectURL(new Blob([data], { type: type }));
    a.attr("href", url);
    a.attr("download", name);
    $("body").append(a);
    a[0].click();
    window.URL.revokeObjectURL(url);
    a.remove();
}

class History extends Component {
    state = {
        status: 1,
        endDate: null,
        beginDate: null,
        currentPage: 1,
        lastPage: 0,
        instructionHistoryList: [],
        id: null,
        checkedItems: [],
        selectAllChecked: false,
        verificationOpen: false,
        verificationCode: null,
        orderTypes: [{
            id: null,
            label: this.props.t('all')
        },
        {
            id: 1,
            label: this.props.t('Alınmalı')
        },
        {
            id: 2,
            label: this.props.t('Doldurulmalı')
        }],
        orderType: null,
        instructionNumber: '',
        bencName: '',
        open: false,
        item: null,
        payType: null,
        payableAmount: '',
        calculatedAmount: '',
        accountId: null
    }

    downloadFile = (bytes, name, type) => {
        let arrrayBuffer = base64ToArrayBuffer(bytes);
        saveFile(name, type, arrrayBuffer)
    }

    getBase64(file, cb) {
        if (file) {
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                cb(reader.result)
            };
            reader.onerror = function (error) {

            };
        }
    }

    updateDate = (name, value) => {
        this.setState({ [name]: value });
    };

    getFormatedDate(date) {
        if (date) {
            let formatedDate = {
                day: (date.getDate() < 10) ? ('0' + date.getDate()) : date.getDate(),
                month: (date.getMonth() < 10) ? ('0' + (date.getMonth() + 1)) : (date.getMonth() + 1),
                year: date.getFullYear().toString()
            }
            return formatedDate.year + '-' + formatedDate.month + '-' + formatedDate.day;
        }
        return null;
    }

    selectPage(e, page) {
        e.preventDefault();
        this.setState({ currentPage: page }, () => this.getInstructionPayHistory())
    }

    componentDidMount() {
        this.getInstructionPayHistory();
    }

    getInstructionPayHistory = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let getInstructionPayHistoryRequestBody = {
            token: localStorage.getItem('token'),
            beginDate: this.getFormatedDate(this.state.beginDate),
            endDate: this.getFormatedDate(this.state.endDate),
            orderType: this.state.orderType,
            bencName: this.state.bencName.trim(),
            pageNumber: this.state.currentPage,
        }
        fetch(request("instruction/getInstructionPayHistory", getInstructionPayHistoryRequestBody))
            .then(res => res.text())
            .then((getInstructionPayHistoryResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getInstructionPayHistoryResponse = JSON.parse(getInstructionPayHistoryResponseJSON);
                if (getInstructionPayHistoryResponse.status.statusCode !== 1) {
                    if (getInstructionPayHistoryResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getInstructionPayHistoryResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                else {
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                    this.setState({ item: null, lastPage: getInstructionPayHistoryResponse.totalPage, instructionHistoryList: getInstructionPayHistoryResponse.instructionHistoryList ? getInstructionPayHistoryResponse.instructionHistoryList : [] });
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    getAdocFile = (adocId, filename) => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let getAdocFileRequestBody = {
            token: localStorage.getItem('token'),
            adocId
        }
        fetch(request("instruction/getAdocFile", getAdocFileRequestBody))
            .then(res => res.text())
            .then((getAdocFileResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getAdocFileResponse = JSON.parse(getAdocFileResponseJSON);
                if (getAdocFileResponse.status.statusCode !== 1) {
                    if (getAdocFileResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getAdocFileResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                else {
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                    let arrrayBuffer = base64ToArrayBuffer(getAdocFileResponse.file);
                    saveFile(`${filename}.adoc`, "application/adoc", arrrayBuffer)
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    render() {
        let { verificationOpen, verificationCode, instructionHistoryList, selectAllChecked, checkedItems, orderTypes, orderType, beginDate, endDate, instructionNumber, bencName,
            open, item, data, checked, payType, payableAmount, accountId, calculatedAmount
        } = this.state;
        let { t, alertState } = this.props;
        return (
            <>
                <div className="dashboard-header-route">
                    <div className="dashboard-header-route-left">
                        <button onClick={() => this.props.history.goBack()}>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.7344 21.2188L12.6719 20.3281C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.32812 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z" fill="#2E3131" />
                            </svg>
                        </button>
                        <h2>{t('Tax orders')}</h2>
                    </div>
                </div>
                <div className="dashboard-salary-container">
                    <div className="dashboard-salary-container-data-section" style={{ marginTop: '1px' }}>
                        <div className="dashboard-transfer-list-header">
                            <div className="dashboard-transfer-list-header-container dashboard-transfer-list-header-container__left">
                                <NavLink exact to="/dashboard/decree/list" className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t("Active orders")}</NavLink>
                                <NavLink exact to="/dashboard/decree/history" className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t("history")}</NavLink>
                                <NavLink exact to="/dashboard/decree/other-bank-paid" className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t("Other bank paid orders")}</NavLink>
                            </div>
                        </div>
                        <div className="dashboard-salary-order-container">
                            <div className="dashboard-salary-order-container-box flex-nowrap">
                                <div className="dashboard-salary-order-container-box-select">
                                    <label>{t("Document type")}</label>
                                    <Autocomplete
                                        options={orderTypes}
                                        value={orderTypes.find(item => item.id == orderType) || orderTypes[0]}
                                        onChange={(event, value) => this.setState({ orderType: value.id })}
                                        disableClearable
                                        renderInput={(params) => <TextField {...params} />}
                                    />
                                </div>
                                <div className="dashboard-salary-order-container-box-select">
                                    <label>{t("Sending organization")}</label>
                                    <TextField value={bencName} onChange={(e) => this.setState({ bencName: e.target.value })} />
                                </div>
                                <div className="dashboard-salary-order-container-box-select">
                                    <label>{t("Started date")}</label>
                                    <div className="dashboard-salary-order-container-box-select-datepicker-input">
                                        <StartDatePicker value={beginDate} name="beginDate" endDate={endDate} disableFuture={true} updateDate={this.updateDate} />
                                    </div>
                                </div>
                                <div className="dashboard-salary-order-container-box-select">
                                    <label>{t("expiration date")}</label>
                                    <div className="dashboard-salary-order-container-box-select-datepicker-input">
                                        <EndDatePicker value={endDate} name="endDate" beginDate={beginDate} disableFuture={true} updateDate={this.updateDate} />
                                    </div>
                                </div>
                            </div>
                            <div className="dashboard-salary-order-container-box justify-content-end">
                                <button className="dashboard-salary-order-container-box-button dashboard-salary-order-container-box-button-main" onClick={this.getInstructionPayHistory}>{t("Search")}</button>
                                <button className="dashboard-salary-order-container-box-button dashboard-salary-order-container-box-button-outline" onClick={() => this.setState({ orderType: orderTypes[0].id, bencName: '', beginDate: null, endDate: null })}>{t("Clear")}</button>
                            </div>
                            {instructionHistoryList.length === 0 ?
                                <div className="dashboard-last-operations-section-content" style={{ justifyContent: 'center' }}>
                                    <img src={lastOperationsIcon} className="dashboard-last-operations-section-content-image" alt="lastOperationsIcon" />
                                    <p className="dashboard-last-operations-section-content-status">{t('you do not currently have any active transactions')}</p>
                                </div>
                                : <>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>{t("date")}</th>
                                                <th>{t("Sending organization")}</th>
                                                <th>{t("Document type")}</th>
                                                <th>{t("Amount")}</th>
                                                <th>{t("amount paid")}</th>
                                                <th>{t("Balance")}</th>
                                                <th>{t("Document")}</th>
                                                <th>{t("ADOC")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {instructionHistoryList.length !== 0 && instructionHistoryList.map(item => (
                                                <tr>
                                                    <td>{item.billingDate || '--'}</td>
                                                    <td>{item.bencName || '--'}</td>
                                                    <td>{item.collTypeName || '--'}</td>
                                                    <td>{item.totalAmount || '--'}</td>
                                                    <td>{item.payAmount || '--'}</td>
                                                    <td>{item.remainingDebt}</td>
                                                    <td>
                                                        <button onClick={() => this.downloadFile(item?.document, `${item?.bencName} / ${item?.receiptNumber}`, "application/pdf")}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                <path d="M2.70039 2.4C2.70039 1.2402 3.64059 0.3 4.80039 0.3H14.2761L21.3004 7.32426V21.6C21.3004 22.7598 20.3602 23.7 19.2004 23.7H4.80039C3.64059 23.7 2.70039 22.7598 2.70039 21.6V2.4Z" stroke="#344054" stroke-width="0.6" />
                                                                <path d="M14.4004 0L21.6004 7.2H16.8004C15.4749 7.2 14.4004 6.12548 14.4004 4.8V0Z" fill="#344054" />
                                                                <path d="M15.0449 15.1168C14.4461 15.1168 13.6966 15.2212 13.4514 15.258C12.4367 14.1983 12.1479 13.5959 12.083 13.4353C12.171 13.2092 12.4772 12.3502 12.5207 11.2469C12.5422 10.6946 12.4255 10.2818 12.1738 10.0202C11.9226 9.75896 11.6185 9.73865 11.5313 9.73865C11.2255 9.73865 10.7126 9.89327 10.7126 10.9287C10.7126 11.8271 11.1314 12.7804 11.2472 13.0267C10.6372 14.803 9.98224 16.0189 9.84317 16.269C7.39189 17.1919 7.2002 18.0843 7.2002 18.3372C7.2002 18.7917 7.52387 19.063 8.06602 19.063C9.38324 19.063 10.5853 16.8516 10.784 16.4676C11.7196 16.0948 12.9717 15.8639 13.29 15.8088C14.2031 16.6786 15.2591 16.9107 15.6976 16.9107C16.0275 16.9107 16.8002 16.9107 16.8002 16.1162C16.8002 15.3785 15.8547 15.1168 15.0449 15.1168ZM14.9814 15.6383C15.6929 15.6383 15.8809 15.8736 15.8809 15.998C15.8809 16.0761 15.8513 16.3308 15.4699 16.3308C15.128 16.3308 14.5375 16.1331 13.9566 15.7043C14.1989 15.6725 14.5574 15.6383 14.9814 15.6383ZM11.4939 10.2442C11.5588 10.2442 11.6015 10.265 11.6367 10.3138C11.8414 10.5978 11.6764 11.5256 11.4755 12.2516C11.2817 11.6291 11.1362 10.6738 11.3409 10.3378C11.3809 10.2722 11.4266 10.2442 11.4939 10.2442ZM11.1484 15.8014C11.406 15.281 11.6947 14.5226 11.852 14.0937C12.1666 14.6204 12.5899 15.1095 12.8347 15.3746C12.0725 15.5353 11.4958 15.6958 11.1484 15.8014ZM7.71188 18.4066C7.69491 18.3865 7.6924 18.3441 7.70519 18.2931C7.732 18.1864 7.93695 17.6573 9.41928 16.9942C9.20703 17.3285 8.87521 17.8062 8.51069 18.1631C8.25409 18.4033 8.05429 18.5251 7.91682 18.5251C7.86764 18.5251 7.79989 18.5117 7.71188 18.4066Z" fill="#344054" />
                                                            </svg>
                                                        </button>
                                                    </td>
                                                    <td>
                                                        <button onClick={() => this.getAdocFile(item?.adocId, `${item?.bencName} ${item?.receiptNumber}`)}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" stroke-width="1.5" viewBox="0 0 24 24" fill="none">
                                                                <path d="M6 20L18 20" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M12 4V16M12 16L15.5 12.5M12 16L8.5 12.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
                                                            </svg>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div style={{ width: '100%', marginTop: '15px', marginBottom: '15px', display: 'flex', justifyContent: 'center' }}>
                                        <ul className="dashboard-pagination">
                                            {this.state.currentPage != 1 && <li><a href="#" onClick={(e) => this.selectPage(e, this.state.currentPage - 1)}>{t('previous-page')}</a></li>}
                                            {
                                                Array.from({ length: this.state.lastPage }).map((item, index) => {
                                                    if (this.state.lastPage > 3) {
                                                        if (this.state.currentPage - 1 == index + 1) {
                                                            return (
                                                                <>
                                                                    {this.state.currentPage > 2 && <li><a href="#" onClick={(e) => this.selectPage(e, 1)}>1</a></li>}

                                                                    {this.state.currentPage > 3 && <li><a href="#" style={{ cursor: 'default' }} onClick={(e) => { e.preventDefault(); }}>...</a></li>}
                                                                    <li><a href="#" onClick={(e) => this.selectPage(e, index + 1)}>{index + 1}</a></li>
                                                                </>
                                                            )
                                                        }
                                                        if (this.state.currentPage == index + 1) {
                                                            return (
                                                                <>
                                                                    <li className="active" ><a href="#" style={{ cursor: 'default' }} onClick={e => e.preventDefault()}>{index + 1}</a></li>
                                                                </>
                                                            )
                                                        }
                                                        if (this.state.currentPage + 1 == index + 1) {
                                                            return (
                                                                <>
                                                                    <li><a href="#" onClick={(e) => this.selectPage(e, index + 1)}>{index + 1}</a></li>
                                                                    {this.state.currentPage < this.state.lastPage - 2 && <li ><a href="#" style={{ cursor: 'default' }} onClick={(e) => { e.preventDefault(); }}>...</a></li>}
                                                                    {this.state.currentPage + 1 < this.state.lastPage && <li ><a href="#" onClick={(e) => this.selectPage(e, this.state.lastPage)}>{this.state.lastPage}</a></li>}
                                                                </>
                                                            )
                                                        }
                                                    } else {
                                                        return (
                                                            <li className={index + 1 == this.state.currentPage ? "active" : ""}><a href="#" style={this.state.lastPage == 1 ? { borderRadius: '5px' } : {}} onClick={(e) => this.selectPage(e, index + 1)}>{index + 1}</a></li>
                                                        )
                                                    }
                                                })
                                            }
                                            {this.state.currentPage != this.state.lastPage && this.state.lastPage > 1 && <li><a href="#" onClick={(e) => this.selectPage(e, this.state.currentPage + 1)}>{t('next-page')}</a></li>}
                                        </ul>
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default translate("translation")(History);